import { spiritoryWebApi } from '@/lib/axios/SpiritoryWebApi/spiritoryWebApi';
import { BaseApiResponse, SpiritoryWebEndpoints } from '@/types/api/api-v2';
import { Collection } from '@/types/other';
import { getValidLocale } from '@/utilites/language/language.utils';
import type { CollectionQueryName } from '@/utilites/strapi-proxy-queries';

export default async function getCollections(
  name: CollectionQueryName,
  locale: string = 'en',
  slugs?: string[]
): Promise<Collection[]> {
  try {
    const validLocale = getValidLocale(locale);
    const slugsParam = slugs?.length ? `&slugs=${encodeURIComponent(slugs.join(','))}` : '';
    const finalURL =
      `/collection?name=${name}&locale=${validLocale}${slugsParam}` as SpiritoryWebEndpoints;
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<Collection[]>>(finalURL);
    return data;
  } catch (e) {
    throw new Error('Failed to fetch bottle of the day');
  }
}
